import { asField } from 'informed';
import { taggedTemplateLiteral as _taggedTemplateLiteral, objectWithoutProperties as _objectWithoutProperties, slicedToArray as _slicedToArray, objectSpread2 as _objectSpread2, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { css } from 'styled-components';
import styled from '../../theming/styled-components.js';
import themes from '../../theming/themes.js';
import React, { useState, useMemo, useCallback, useEffect } from 'react';
import withDefaultTheme from '../../hocs/withDefaultTheme.js';
import _Icon from '../Icon/index.js';
import _InputMessage from '../InputMessage/index.js';
import InputContainer from '../InputContainer/index.js';
import _Label from '../Label/index.js';
import invariant from 'invariant';
import _ToolTip from '../ToolTip/index.js';

var _excluded = ["fieldApi", "fieldState"],
  _excluded2 = ["ariaLabelText", "backgroundColor", "disabled", "datePickerIcon", "datePickerValue", "field", "forwardedRef", "helperText", "hideLabel", "icon", "iconColor", "initialValue", "invertColors", "label", "language", "loading", "onBlur", "onChange", "onFocus", "optional", "placeholder", "resize", "success", "skinny", "showToolTip", "textarea", "theme", "toggleShowPassword", "toolTipText", "type", "validate"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;
var StyledDiv = styled('div')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  text-align: left;\n  margin-bottom: ", ";\n  background-color: inherit;\n"])), function (_ref) {
  var _ref$skinny = _ref.skinny,
    skinny = _ref$skinny === void 0 ? false : _ref$skinny;
  return skinny ? 0 : '1.375rem';
});
var StyledInput = styled('input')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  outline: none;\n  padding: 12px;\n  font-family: ", ";\n  padding-left: ", ";\n  padding-right: ", ";\n  font-size: 1rem;\n  font-weight: 400;\n  width: ", ";\n  min-width: ", ";\n  resize: ", ";\n  min-height: ", ";\n  height: ", ";\n  color: ", ";\n  border: ", "\n  border-color: ", ";\n  border-radius: 2px;\n  background-color: ", ";\n\n  &:focus {\n    outline: none;\n    border: ", "\n      ", ";\n    box-shadow: ", ";\n  }\n\n  &::placeholder {\n    font-family: inherit;\n    color: ", ";\n  }\n  &[disabled] {\n    opacity: 0.3;\n  }\n\n  // Handle label position & value prefill in some browsers\n  @keyframes autofill {\n  }\n  @keyframes noAutofill {\n  }\n\n  &:-webkit-autofill {\n    animation-name: autofill;\n  }\n\n  &:not(:-webkit-autofill) {\n    animation-name: noAutofill;\n  }\n  ", ";\n"])), function (_ref2) {
  var textmask = _ref2.textmask,
    showPassword = _ref2.showPassword,
    value = _ref2.value;
  return textmask && !showPassword && value ? 'password' : 'inherit';
}, function (_ref3) {
  var icon = _ref3.icon;
  return icon ? '2.25rem' : '0.6875rem';
}, function (_ref4) {
  var loading = _ref4.loading;
  return loading === 'true' ? '2.5rem' : '.875rem';
}, function (_ref5) {
  var textarea = _ref5.textarea,
    _ref5$cols = _ref5.cols,
    cols = _ref5$cols === void 0 ? 0 : _ref5$cols;
  return textarea && cols ? cols : '100%';
}, function (_ref6) {
  var textarea = _ref6.textarea,
    _ref6$cols = _ref6.cols,
    cols = _ref6$cols === void 0 ? 0 : _ref6$cols;
  return textarea && cols ? cols : '100%';
}, function (_ref7) {
  var resize = _ref7.resize;
  return resize;
}, function (_ref8) {
  var textarea = _ref8.textarea,
    _ref8$rows = _ref8.rows,
    rows = _ref8$rows === void 0 ? 0 : _ref8$rows;
  return textarea ? rows || '10rem' : 'auto';
}, function (_ref9) {
  var textarea = _ref9.textarea;
  return textarea ? '' : '2.375rem';
}, function (_ref10) {
  var theme = _ref10.theme,
    invertColors = _ref10.invertColors;
  return invertColors ? theme.palette.white : theme.palette.black;
}, function (_ref11) {
  var textarea = _ref11.textarea;
  return !textarea ? 'none' : 'solid 2px';
}, function (_ref12) {
  var theme = _ref12.theme,
    error = _ref12.error,
    success = _ref12.success,
    invertColors = _ref12.invertColors,
    disabled = _ref12.disabled;
  if (invertColors) {
    return theme.palette.white;
  } else {
    if (error) {
      return theme.palette.errorDark;
    } else if (success) {
      return theme.palette.success;
    }
    if (disabled) {
      return theme.palette.grayDarker;
    }
    return theme.palette.gray;
  }
}, function (_ref13) {
  var theme = _ref13.theme,
    error = _ref13.error,
    focus = _ref13.focus,
    invertColors = _ref13.invertColors,
    disabled = _ref13.disabled;
  if (invertColors) {
    return 'transparent';
  }
  if (disabled) {
    return theme.palette.grayLight;
  }
  if (!focus && error) {
    return theme.palette.errorLightest;
  }
}, 'none', function (_ref14) {
  var theme = _ref14.theme,
    invertColors = _ref14.invertColors;
  return invertColors ? theme.palette.white : theme.palette[theme.input.focusBorderColor];
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.boxShadow.buttonFocus;
}, function (_ref16) {
  var invertColors = _ref16.invertColors,
    theme = _ref16.theme;
  return invertColors && theme.palette.white;
}, function (_ref17) {
  var disabled = _ref17.disabled;
  return disabled ? 'cursor: not-allowed' : null;
});
var StyledLfgLabel = styled(_Label)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-style: ", ";\n  font-size: 1rem;\n  font-weight: 400;\n  position: absolute;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  pointer-events: none;\n  transform-origin: top left;\n  left: 0;\n  top: -2px;\n  margin-left: ", ";\n  transition: transform 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;\n  transform: translate(-2px, 10px) scale(1);\n  background-color: ", ";\n  background: ", "\n    ", ";\n"])), function (_ref18) {
  var theme = _ref18.theme,
    focus = _ref18.focus,
    value = _ref18.value,
    invertColors = _ref18.invertColors;
  return invertColors ? theme.palette.white : !focus && !value ? theme.palette.gray : theme.palette.grayDark;
}, function (_ref19) {
  var autofilled = _ref19.autofilled,
    focus = _ref19.focus,
    value = _ref19.value;
  return !autofilled && !focus && !value ? 'italic' : 'none';
}, function (_ref20) {
  var icon = _ref20.icon;
  return icon ? '2.25rem' : '0.625rem';
}, function (_ref21) {
  var invertColors = _ref21.invertColors,
    _ref21$backgroundColo = _ref21.backgroundColor,
    backgroundColor = _ref21$backgroundColo === void 0 ? 'white' : _ref21$backgroundColo,
    theme = _ref21.theme;
  return invertColors && !!backgroundColor && theme.palette[backgroundColor];
}, function (_ref22) {
  var invertColors = _ref22.invertColors,
    error = _ref22.error,
    theme = _ref22.theme,
    focus = _ref22.focus,
    disabled = _ref22.disabled;
  return !invertColors && !disabled && css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["linear-gradient(\n    transparent 48%,\n      ", "\n  );"])), error && !focus ? "".concat(theme.palette.errorLightest, " 40%") : "".concat(theme.palette.white, " 40%"));
}, function (_ref23) {
  var autofilled = _ref23.autofilled,
    focus = _ref23.focus,
    value = _ref23.value;
  return (autofilled || focus || value) && css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    margin-left: ", ";\n    padding: 0px 4px;\n    transform-origin: top left;\n    transform: translate(-4px,-10px) scale(.80);    \n  "])), function (_ref24) {
    var icon = _ref24.icon;
    return icon ? '1.875rem' : '0.25rem';
  });
});
var StyledIcon = styled(_Icon)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  left: 0.625rem;\n  opacity: ", ";\n"])), function (_ref25) {
  var disabled = _ref25.disabled;
  return disabled ? 0.3 : 1;
});
// const StyledLoaderDots = styled(Dots)<{ isShown: boolean }>`
//   font-size: 3px;
//   margin: 0;
//   position: absolute;
//   right: 0.625rem;
//   top: 50%;
//   transform: translateY(-50%);
// `;
var StyledToggleShowPasswordButton = styled('button')(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  right: 0.625rem;\n\n  background-color: transparent;\n  border-radius: none;\n  border: none;\n  color: ", ";\n  opacity: ", ";\n  &:hover {\n    cursor: ", ";\n  }\n"])), function (_ref26) {
  var theme = _ref26.theme,
    invertColors = _ref26.invertColors;
  return invertColors ? theme.palette.white : theme.palette.secondary;
}, function (_ref27) {
  var disabled = _ref27.disabled;
  return disabled ? 0.3 : 1;
}, function (_ref28) {
  var disabled = _ref28.disabled;
  return disabled ? 'not-allowed' : 'pointer';
});
var StyledToolTipContainer = styled('button')(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  right: 0.625rem;\n\n  background-color: transparent;\n  border-radius: none;\n  border: none;\n  color: ", ";\n  z-index: 99;\n"])), function (_ref29) {
  var theme = _ref29.theme,
    invertColors = _ref29.invertColors;
  return invertColors ? theme.palette.white : theme.palette.secondary;
});
var StyledErrorIconContainer = styled('div')(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  right: ", ";\n\n  background-color: transparent;\n  border-radius: none;\n  border: none;\n  color: ", ";\n"])), function (_ref30) {
  var hasDatePickerIcon = _ref30.hasDatePickerIcon;
  return hasDatePickerIcon ? '2.5rem' : '0.625rem';
}, function (_ref31) {
  var theme = _ref31.theme,
    invertColors = _ref31.invertColors;
  return invertColors ? theme.palette.white : theme.palette.secondary;
});
var TextInput = function TextInput(_ref32) {
  var fieldApi = _ref32.fieldApi,
    fieldState = _ref32.fieldState,
    props = _objectWithoutProperties(_ref32, _excluded);
  var maskedValue = fieldState.maskedValue,
    error = fieldState.error;
  var setValue = fieldApi.setValue,
    setTouched = fieldApi.setTouched;
  var ariaLabelText = props.ariaLabelText,
    backgroundColor = props.backgroundColor,
    disabled = props.disabled,
    _props$datePickerIcon = props.datePickerIcon,
    datePickerIcon = _props$datePickerIcon === void 0 ? function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null);
    } : _props$datePickerIcon,
    datePickerValue = props.datePickerValue,
    field = props.field,
    forwardedRef = props.forwardedRef,
    helperText = props.helperText,
    hideLabel = props.hideLabel,
    icon = props.icon,
    _props$iconColor = props.iconColor,
    iconColor = _props$iconColor === void 0 ? 'gray' : _props$iconColor,
    initialValue = props.initialValue,
    _props$invertColors = props.invertColors,
    invertColors = _props$invertColors === void 0 ? false : _props$invertColors,
    label = props.label,
    _props$language = props.language,
    language = _props$language === void 0 ? 'en' : _props$language,
    _props$loading = props.loading,
    loading = _props$loading === void 0 ? false : _props$loading,
    onBlur = props.onBlur,
    onChange = props.onChange,
    onFocus = props.onFocus,
    _props$optional = props.optional,
    optional = _props$optional === void 0 ? false : _props$optional,
    placeholder = props.placeholder,
    _props$resize = props.resize,
    resize = _props$resize === void 0 ? 'auto' : _props$resize,
    success = props.success,
    _props$skinny = props.skinny,
    skinny = _props$skinny === void 0 ? false : _props$skinny,
    _props$showToolTip = props.showToolTip,
    showToolTip = _props$showToolTip === void 0 ? false : _props$showToolTip,
    textarea = props.textarea,
    _props$theme = props.theme,
    theme = _props$theme === void 0 ? themes["default"] : _props$theme,
    toggleShowPassword = props.toggleShowPassword,
    toolTipText = props.toolTipText,
    _props$type = props.type,
    type = _props$type === void 0 ? 'text' : _props$type,
    validate = props.validate,
    rest = _objectWithoutProperties(props, _excluded2);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    focus = _useState2[0],
    setFocus = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showPassword = _useState4[0],
    setShowPassword = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isAutoFill = _useState6[0],
    setIsAutoFill = _useState6[1];
  var displayErrorMessage = error;
  var displayHelperText = helperText && focus;
  var displaySuccess = error === undefined && maskedValue && success ? true : false;
  var helperTextId = useMemo(function () {
    return "".concat(field, "-helper-text");
  }, [field]);
  var errorMessageId = useMemo(function () {
    return "".concat(field, "-error-message");
  }, [field]);
  var handleShowPassword = function handleShowPassword() {
    return function (e) {
      e.preventDefault();
      setFocus(true);
      setShowPassword(function (previousVal) {
        return !previousVal;
      });
    };
  };
  var handleShowToolTip = function handleShowToolTip() {
    return function (e) {
      e.preventDefault();
      setFocus(true);
    };
  };
  var handleChange = useCallback(function (e) {
    setValue(e.target.value);
    if (onChange) {
      onChange(e);
    }
  }, [setValue, onChange]);
  var handleBlur = useCallback(function (e) {
    setTouched(true);
    setFocus(false);
    if (onBlur) {
      onBlur(e);
    }
  }, [setTouched, onBlur]);
  var handleFocus = useCallback(function (e) {
    setFocus(true);
    if (onFocus) {
      onFocus(e);
    }
  }, [setFocus, onFocus]);
  var handleAutoFill = function handleAutoFill(event) {
    setIsAutoFill(event.animationName === 'autofill');
  };
  var describedBy = useMemo(function () {
    if (displayHelperText) {
      return helperTextId;
    } else if (displayErrorMessage) {
      return errorMessageId;
    }
  }, [displayHelperText, helperTextId]);
  invariant(typeof label === 'string' || typeof label !== 'string' && !!ariaLabelText, 'You must provide ariaLabelText when using a jsx label.');
  invariant(typeof label === 'string' || typeof label !== 'string', 'You cannot pass a JSX label to an LFG styled input.');
  invariant(!(showToolTip && toggleShowPassword), 'You cannot have a tooltip and showpassword icon displayed at same time.');
  invariant(!(showToolTip && (!toolTipText || toolTipText === 'undefined')), 'You must pass toolTipText to display in tooltip.');
  useEffect(function () {
    if (datePickerValue) {
      setValue(datePickerValue);
    }
  }, [datePickerValue]);
  var _rest = _objectSpread2({}, rest),
    hidden = _rest.hidden;
  return /*#__PURE__*/React.createElement(StyledDiv, {
    skinny: skinny,
    hidden: hidden
  }, /*#__PURE__*/React.createElement(InputContainer, {
    theme: theme,
    error: error,
    success: displaySuccess,
    focus: focus,
    invertColors: invertColors,
    disabled: disabled,
    textarea: textarea
  }, icon && /*#__PURE__*/React.createElement(StyledIcon, {
    "aria-hidden": true,
    color: invertColors ? 'white' : iconColor,
    disabled: disabled,
    name: icon,
    size: 'small',
    theme: theme
  }), /*#__PURE__*/React.createElement(StyledInput, _extends({}, rest, {
    "aria-controls": displayErrorMessage ? errorMessageId : undefined,
    "aria-describedby": displayHelperText ? describedBy : undefined,
    "aria-invalid": displayErrorMessage && error ? true : false,
    as: textarea ? 'textarea' : 'input',
    disabled: disabled,
    error: error,
    focus: focus,
    icon: icon,
    id: field,
    invertColors: invertColors,
    loading: "".concat(loading),
    onAnimationStart: handleAutoFill,
    onBlur: handleBlur,
    onChange: handleChange,
    onFocus: handleFocus,
    placeholder: !focus && !hideLabel ? undefined : placeholder,
    ref: forwardedRef,
    resize: resize,
    showPassword: showPassword,
    success: displaySuccess,
    textarea: textarea,
    textmask: type === 'textmask',
    theme: theme,
    type: showPassword || type === 'textmask' ? 'text' : type,
    validate: validate,
    value: maskedValue || initialValue || ''
  })), /*#__PURE__*/React.createElement(StyledLfgLabel, {
    "aria-owns": field,
    autofilled: isAutoFill,
    backgroundColor: backgroundColor,
    "data-testid": 'lfgStyle-input-label',
    disabled: disabled,
    error: !!error,
    focus: focus,
    hidden: hideLabel,
    htmlFor: field,
    icon: icon ? true : false,
    invertColors: invertColors,
    language: language,
    optional: optional,
    theme: theme,
    value: !!maskedValue ? 'hasValue' : undefined
  }, label), /*#__PURE__*/React.createElement(React.Fragment, null, toggleShowPassword && !displayErrorMessage && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledToggleShowPasswordButton, {
    "aria-hidden": true,
    "aria-label": showPassword ? 'Hide Password' : 'Show Password',
    className: 'align-items-center d-flex ml-auto',
    "data-testid": 'toggle-show-password-button',
    disabled: disabled,
    onMouseDown: handleShowPassword(),
    type: 'button',
    theme: theme,
    tabIndex: -1,
    invertColors: invertColors
  }, /*#__PURE__*/React.createElement(_Icon, {
    name: !showPassword ? 'eye-open' : 'eye-closed',
    color: invertColors ? 'white' : 'secondaryDark',
    size: 'medium',
    theme: theme
  }))), showToolTip && !displayErrorMessage && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledToolTipContainer, {
    "aria-hidden": true,
    "aria-label": 'Tool tip',
    className: 'align-items-center d-flex ml-auto',
    "data-testid": 'tooltip-div',
    invertColors: invertColors,
    onMouseDown: handleShowToolTip(),
    tabIndex: -1,
    theme: theme
  }, /*#__PURE__*/React.createElement(_ToolTip, {
    iconColor: invertColors ? 'white' : 'secondaryDark',
    toolText: toolTipText,
    position: 'top',
    showOnHover: false,
    iconSize: 'small'
  }))), !!datePickerIcon && datePickerIcon, displayErrorMessage && error && !skinny && !textarea ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledErrorIconContainer, {
    className: 'align-items-center d-flex ml-auto',
    "data-testid": 'lfg-error-icon',
    hasDatePickerIcon: !!datePickerIcon,
    theme: theme,
    invertColors: invertColors
  }, /*#__PURE__*/React.createElement(_Icon, {
    "aria-hidden": true,
    color: invertColors ? 'white' : 'error',
    name: "warning",
    size: 'medium',
    theme: themes.secureSite
  }))) : null)), displayHelperText && /*#__PURE__*/React.createElement(_InputMessage, {
    id: helperTextId,
    focus: focus,
    invertColors: invertColors
  }, helperText), /*#__PURE__*/React.createElement(_InputMessage, {
    style: {
      marginTop: '5px'
    },
    "aria-live": 'assertive',
    error: !!error,
    hidden: !displayErrorMessage,
    id: errorMessageId,
    invertColors: invertColors,
    role: 'alert',
    showIcon: !textarea ? false : true,
    theme: themes.secureSite
  }, displayErrorMessage && error ? error : ''));
};
// @ts-ignore
var _TextInput = withDefaultTheme(asField(TextInput));

export default _TextInput;
